import Dexie from 'dexie';
import { TableName } from './constants';
// TODO: Do not initailize DB at the top level of the app.
// As it may break when the indexedDB API isn't available.
const db = new Dexie('OfflineSyncDatabase_v2');
db.version(1).stores({
    [TableName.QNA_NODE]: '_id, _syncBoxId, _status, type, *ancestors, data.duplicateRef, utime',
    [TableName.QNA_NODE_USER]: '_id, _syncBoxId, _status, entityRef, userID, utime',
    [TableName.SYNC_BOX_CONFIG]: 'id, collectionName, remoteCollectionName',
    [TableName.SYNC_BOX_STATE]: 'configId, lastPulledAt, lastPulledId, lastSyncedTs'
});
export default db;
